import { useQuery } from "@hooks/use_query";
import * as types from "@root/types";
import { api } from "@services/api";
import { useEffect, useMemo } from "react";

interface UseFetchPressItemProps {
  id?: number | string;
}

const EMPTY_PRESS_ITEM = {
  description: undefined,
  headline: undefined,
  id: undefined,
  link: undefined,
  publishedDate: undefined,
  source: undefined,
  slug: undefined,
  tagline: undefined,
};

const useFetchPressItem = ({ id }: UseFetchPressItemProps) => {
  const apiCall = useMemo(() => {
    if (!id) {
      return (_token: string) => () =>
        Promise.resolve({ data: EMPTY_PRESS_ITEM, errors: undefined });
    }
    return (token: string) => () =>
      api.pressItems.details(token, id.toString());
  }, [id]);
  const {
    data,
    fetchData: fetchPressItem,
    loading,
    error,
  } = useQuery<types.PressItemDetailResponse, UseFetchPressItemProps>(apiCall);

  useEffect(() => {
    fetchPressItem({ id });
  }, [fetchPressItem, id]);

  return {
    pressItem: data,
    loading,
    error,
  };
};

export { useFetchPressItem };
